import cuenta_contable from "./cuenta_contable"
export default {
    cuenta_contable,
}